export const APPOINTMENT_SETTINGS_ROLES = Object.freeze([
  "Super Administrator",
  "Administrator",
]);

export const hasAppointmentSettingsAccess = user =>
  !!user &&
  Array.isArray(user.roles) &&
  user.roles.some(
    role => role && APPOINTMENT_SETTINGS_ROLES.includes(role.name),
  );
